import Cookies from "js-cookie";

export const useAuthState = () => {
  const token = localStorage.getItem("access_token");
  const currentUser = Cookies.get("currentUser");

  let parsedUser = null;

  try {
    parsedUser = currentUser
      ? JSON.parse(decodeURIComponent(currentUser))
      : null;
  } catch (error) {
    console.error("Invalid currentUser cookie:", error);
  }

  const isAuthenticated = !!token && !!parsedUser;

  return {
    isAuthenticated,
  };
};